"use client";

interface CheckboxFieldProps {
  id: string;
  label: string;
  hint?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function CheckboxField({
  id,
  label,
  hint,
  checked,
  onChange,
}: CheckboxFieldProps) {
  return (
    <div
      className={`flex items-start gap-3 p-4 rounded-lg cursor-pointer transition-colors border select-none ${
        checked
          ? "bg-blue-50/30 dark:bg-slate-700/35 border-blue-200 dark:border-slate-800"
          : "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800/80 hover:bg-slate-50/50 dark:hover:bg-slate-800/30"
      }`}
      onClick={() => onChange(!checked)}
    >
      <input
        type="checkbox"
        id={id}
        className="w-4 h-4 rounded border-slate-350 dark:border-slate-700 accent-blue-600 dark:accent-blue-400 cursor-pointer mt-0.5"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        onClick={(e) => e.stopPropagation()}
      />
      <div className="flex flex-col gap-0.5">
        <label
          htmlFor={id}
          className="text-xs font-bold uppercase tracking-wider cursor-pointer text-slate-800 dark:text-slate-200"
          onClick={(e) => e.stopPropagation()}
        >
          {label}
        </label>
        {hint && (
          <p className="text-xs text-slate-450 dark:text-slate-500 font-medium">
            {hint}
          </p>
        )}
      </div>
    </div>
  );
}
